// extracted by mini-css-extract-plugin
export default {"spinContainer":"loader_spinContainer__jRGSi"};